<template>
  <div class="flightNav">
    <div class="airportBox">
      <router-link :to="{name: 'flightinfo'}" class="toAirport airport">{{locale.airport_information}}</router-link>
      <router-link class="airport"
        v-for="airport in airportList"
        :key="airport.airportName"
        :to="{name: 'flightSchedule', params: { airport: airport.airportName }}">
        {{airport.airportName}}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'FlightInfoNav',
  props: [
    'locale',
    'lang'
  ],
  computed: {
    ...mapGetters({
      airportList: 'flightinfo/getAirport'
    }),
    current: {
      get () {
        return this.$route.params.airport
      },
      set (current) {
        this.$router.replace({
          params: {
            airport: current
          }
        })
      }
    }
  },
  created () {
    this.$store.dispatch('flightinfo/getAirport')
  }
}
</script>

<style lang="scss" scoped>
.flightNav {
  display: flex;
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid $color-lgrey2;
  background-color: $color-white;
  box-shadow: 0 0 10px rgba(0,0,0,0.15);
  .airportBox {
    padding: 8px 15px;
    white-space: nowrap;
    overflow: auto;
  }
  .airport {
    display: inline-block;
    margin-right: 4px;
    padding: 0.2em 1em;
    vertical-align: top;
    font-size: 14px;
    color: $color-grey;
    border: 1px solid $color-lgrey2;
    border-radius: 50px;
    &.router-link-exact-active {
      color: $color-white;
      border-color: $color-green;
      background-color: $color-green;
    }
  }
}
</style>
